export function cardSlider() {
  const slider = $(".card-slider");
  const slidesQty = slider.find(".slide").length;
  const totalSlideNum = slider.find(".total-slide-num");
  const curSlideNum = slider.find(".cur-slide-num");
  let isDevice = window.innerWidth < 1280;
  if (isDevice) {
    slider.on("init", function (event, slick) {
      slider.find(".slick-current").addClass("animate");
    });
  }
  (slidesQty < 10) ? totalSlideNum.text(`0${slidesQty}`) : totalSlideNum.text(slidesQty);
  slider.find(".slides").slick({
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    focusOnSelect: true,
    appendArrows: ".card-slider .slider-controls",
    prevArrow: "<button class=\"slick-arrow slick-prev prev-arrow\">" +
    "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27.01 8.52\">\n" +
    "\t<polygon fill=\"#80b127\" points=\"27.01 3.76 2.03 3.76 5.33 0.74 4.66 0 0 4.26 4.66 8.52 5.33 7.78 2.03 4.76 27.01 4.76 27.01 3.76\"/>\n" +
    "</svg>Previous slide</button>",
    nextArrow: "<button class=\"slick-arrow slick-next next-arrow\">" +
    "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27.01 8.52\">\n" +
    "\t<polygon fill=\"#80b127\" points=\"27.01 3.76 2.03 3.76 5.33 0.74 4.66 0 0 4.26 4.66 8.52 5.33 7.78 2.03 4.76 27.01 4.76 27.01 3.76\"/>\n" +
    "</svg>Next slide</button>",
    responsive: [{
      breakpoint: 1280,
      settings: {
        slidesToShow: 1,
        fade: true,
        centerMode: false
      }
    }]
  }).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    if (isDevice) {
      slider.find(".slick-slide").eq(currentSlide).removeClass("animate");
    }
    ((nextSlide + 1) < 10) ? curSlideNum.text(`0${nextSlide + 1}`) : curSlideNum.text(nextSlide + 1);
  }).on("afterChange", function (event, slick, currentSlide) {
    if (isDevice) {
      slider.find(".slick-slide").eq(currentSlide).addClass("animate");
    }
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/cardSlider.js